import { API_URL } from './config'

export class TRoutes {
	static MAIN = '/'
	// Die Lernstrecke Skills4Retail, offen ohne Anmeldung
	static PUBLIC_COURSE = '/skills4retail'
	static AUTH = '/auth'

	static SIGN_IN = `${TRoutes.AUTH}/signin`
	static SIGN_UP = `${TRoutes.AUTH}/signup`
	static RECOVER_PASS = `${TRoutes.AUTH}/request-password-reset`
	static NEW_PASS = `${TRoutes.AUTH}/reset-password/`
	static NEW_PASS_NEW_USER = `${TRoutes.NEW_PASS}new-user`
	static AUTH_CONFIRM = `${TRoutes.AUTH}/confirm`
	static EXPERT_CONFIRM = `${TRoutes.AUTH}/expert/confirm`

	static DASHBOARD = `/dashboard`
	static COMPANIES = `/companies`
	static ADMIN_COMPANIES = `/admin-companies`
	static ADMIN_DOCUMENTS = `/admin-documents`
	static STUDENTS = `/students`
	static DOCUMENTS = `/documents`
	static NOTIFICATIONS = `/notifications`
	// Der Rueckweg der Endnutzer:innen (Anfragen-Konzept, Stufe 3).
	static MY_REQUESTS = `/meine-anfragen`

	static COMPANY = `/company`
	// Ein Abschnitt des Unternehmensprofils. Die Markt- und Risikoanalyse ist
	// seit 08.08.2026 kein eigener Menuepunkt mehr, sondern liegt als Abschnitt
	// im Profil — wer dorthin verweist, nennt den Abschnitt.
	static COMPANY_TAB = (tab = 'basic') => `${TRoutes.COMPANY}?tab=${tab}`
	// Alte Adresse der Risikoanalyse; leitet auf den Abschnitt im Profil um,
	// damit gespeicherte Verweise und Lesezeichen weiter ankommen.
	static COMPANY_INSURANCE = `/company-insurance`
	static COMPANY_REVIEW = (id = ':id') => `/company-review/${id}`
	/*
	 * Dasselbe Unternehmensprofil aus der Sicht der Lehrkraft: derselbe Aufbau
	 * wie bei der Verwaltung, nur lesend. Liegt unter der Unternehmensliste der
	 * Lehrkraft (`/companies`), weil sie von dort geöffnet wird.
	 */
	static TEACHER_COMPANY = (id = ':id') => `${TRoutes.COMPANIES}/${id}`
	// Junior Mini Company (Anforderung #92): eigener Pfad, nicht unter
	// /companies — dort finge `/companies/:id` jede Unterseite ab.
	static MINI_COMPANIES = '/mini-companies'
	static MINI_COMPANY = (id = ':id') => `/mini-companies/${id}`
	static ADMIN_MINI_COMPANIES = '/admin-mini-companies'
	static ADMIN_MINI_COMPANY = (id = ':id') => `/admin-mini-companies/${id}`
	static COMPANY_REPORT_JUNIOR = `/company-report-junior`
	static COMPANY_EMPLOYEE = `${TRoutes.COMPANY}-employee`
	static COMPANY_EXPERTS = `${TRoutes.COMPANY}-experts`
	static COMPANY_EMAIL_VERIFY = `${TRoutes.COMPANY}/email-verify`
	// Nachrichten der Verwaltung zum eigenen bzw. betreuten Unternehmen
	static COMPANY_MESSAGES = (id = ':id') => `/unternehmen-nachrichten/${id}`
	static SHARES = `/shares`
	static REPORTS = `/reports`
	static REPORTS_TABLE = `/reports-table`
	static REPORT_REVIEW = (id = ':id') => `/report/${id}`
	static REPORTS_COMPANY = `${TRoutes.REPORTS}/company`
	static REPORTS_COMPANY_2ND = `${TRoutes.REPORTS}/company/2nd`
	static REPORTS_COMPACT = `${TRoutes.REPORTS}/compact`
	static REPORTS_BASIC = `${TRoutes.REPORTS}/basic`

	static PROFILE = `/profile`
	static EMAIL_CHANGE_CONFIRM = `/confirm/email`
	static STUDENT_EMAIL_CHANGE_CONFIRM = `/student/confirm/email`
	static ADMIN_EMAIL_CHANGE_CONFIRM = `/admin/confirm/email`

	static USERS = `/users`
	static INVOICES = `/invoices`

	static EMAILS = `/emails`
	static NEW_EMAIL_TEMPLATE = `${TRoutes.EMAILS}/new-template`
	static NEWS = `/news`
	static ADMINS = `/admins`
	static SCHOOLS = `/schools`
	static SETTINGS = `/settings`
	static PDFs = `/settings/documents`
	static EXPERTS = `/experts`

	// Unterstuetzer:innen-Modul
	static SUPPORTERS = `/supporters`
	static SUPPORT_REQUESTS = `/unterstuetzungsbedarf`
	static COMMUNICATION = `/kommunikation`
	static HANDBOOK = `/handbuch`
	// Die Schulung liegt unterhalb des Handbuchs: Sie ist dessen Kurzfassung
	// zum Schuljahresstart und wird von dort aus geöffnet.
	static TRAINING = `/handbuch/neues-schuljahr`
	// Vertonte Präsentationen der Verwaltung für Partner (z. B. andere JA-Organisationen)
	static PRESENTATIONS = `/praesentationen`
	static PRESENTATION = (slug = ':slug') => `/praesentationen/${slug}`
	static SUPPORTER_PROFILE = `/supporter-profile`
	static SUPPORTER_CONNECTIONS = `/supporter-connections`
	static SUPPORTER_ACTIVATION = (token = ':token') => `/supporter-activation/${token}`
	static SUPPORTER_REGISTER = `/supporter-registrierung`

	// Anforderungen und Aenderungsliste
	static TICKETS = `/anforderungen`
	static CONCEPT = `/konzept`
	static CONCEPT_REPORT = `/konzept-auswertung`
	/*
	 * Kurse (KI-Kurs und alles, was die Kursverwaltung später dazunimmt).
	 * `/kurse` teilt sich nach Rolle: Schüler:innen lernen, Lehrkräfte sehen
	 * den Stand ihrer Junior Companies, die Verwaltung die Vorschau. Die
	 * Kursverwaltung und die Auswertung sind eigene Seiten der Verwaltung.
	 */
	static COURSES = `/kurse`
	// Kurse von TalentsLounge, eingebettet (seit 01.11.2026 der Menüpunkt „Kurse").
	// `/kurse` mit den eigenen Kursen bleibt als „Kurse (Test)" für Super-Admins.
	static TL_COURSES = `/kursangebot`
	static TL_COURSE = (id = ':id') => `/kursangebot/${id}`
	static COURSE = (id = ':id') => `/kurse/${id}`
	static COURSE_LESSON = (id = ':id', lessonId = ':lessonId') => `/kurse/${id}/lektion/${lessonId}`
	static COURSE_QUIZ = (id = ':id', moduleId = ':moduleId') => `/kurse/${id}/quiz/${moduleId}`
	static ADMIN_COURSES = `/kursverwaltung`
	static ADMIN_COURSE = (id = ':id') => `/kursverwaltung/${id}`
	static COURSE_REPORT = `/kurs-auswertung`
	// Prüfseite der Urkunde — ohne Anmeldung, der QR-Code auf dem Blatt führt hierher.
	static COURSE_CERTIFICATE_CHECK = (code = ':code') => `/urkunde/${code}`
	static CHANGELOG = `/entwicklungen`

	/*
	 * Junior-Bilanz eines Schuljahrs. Bewusst ohne Menueeintrag: Der Bericht
	 * geht an Junior Achievement und wird dort abgestimmt, bevor er jemandem
	 * angeboten wird. Wer den Link hat und Bundesadmin ist, sieht ihn.
	 */
	static ANNUAL_REPORT = `/jahresbericht`

	/*
	 * Die beiden offenen Fassungen desselben Berichts. Ohne Anmeldung
	 * erreichbar, weil der Aufmacher der Startseite, die
	 * Unterstuetzer:innen-Seite und der DaVinciLab-Steckbrief darauf verweisen.
	 *
	 * `PUBLIC_ANNUAL_REPORT` ist die Junior-Bilanz ohne finanzielle Ergebnisse,
	 * `PUBLIC_PLATFORM_REPORT` der Bericht ueber die Plattform selbst.
	 */
	static PUBLIC_ANNUAL_REPORT = `/bilanz`
	static PUBLIC_PLATFORM_REPORT = `/plattform`

	/*
	 * Die DaVinciLab-Seite hinter „Powered by DaVinciLab". Offen, weil sie
	 * gezeigt und verschickt werden soll — sie erklärt einer
	 * Junior-Achievement-Organisation, was die Plattform im Alltag leistet.
	 */
	static PUBLIC_DAVINCILAB = `/davincilab`

	// Oeffentliche Rechtsseiten (ohne Login erreichbar)
	static IMPRESSUM = `/impressum`
	static DATENSCHUTZ = `/datenschutz`
	static NUTZUNGSBEDINGUNGEN = `/nutzungsbedingungen`
	static BARRIEREFREIHEIT = `/barrierefreiheit`

	static CREATE_SCHOOL = `${TRoutes.SCHOOLS}/create`
	static UPDATE_SCHOOL = (id = ':id') => `${TRoutes.SCHOOLS}/update/${id}`
	static UPDATE_COMPANY = (id = ':id') => `${TRoutes.COMPANY}/update/${id}`

	static NOT_FOUND = `/not-found`
}

/*
 * Kennzeichen an der Anmeldeseite nach dem Widerruf der Einwilligung
 * (Anforderung #103). Der Widerruf sperrt das Konto — die Anmeldeseite ist
 * damit die einzige Seite, auf der die Person noch lesen kann, was geschehen
 * ist. Der Wert steht hier, weil ihn zwei Stellen kennen muessen: das
 * Unterstuetzer:innen-Profil setzt ihn, die Anmeldeseite liest ihn.
 */
export const CONSENT_WITHDRAWN_PARAM = 'einwilligung-widerrufen'

export class TApi {
	static SIGN_IN = '/api/public/auth/signin'
	static PUBLIC_AUTH_SING_UP = '/api/public/auth/signup'

	//static SING_UP_USER_STUDENT = '/api/public/auth/signup/student'
	//static SING_UP_USER_STUDENT_INVITE = '/api/public/auth/signup/student/invite'
	//static SING_UP_USER_TEACHER = '/api/public/auth/signup/teacher'
	//static SING_UP_USER_TEACHER_INVITE = '/api/public/auth/signup/teacher/invite'
	static SIGN_UP_CONFIRM = `/api/public/auth/signup/confirm`
	static EXPERT_CONFIRM = 'api/public/auth/experts/confirm'

	static EMAIL_CHANGE_CONFIRM = `/api/private/teacher/profile/email/confirm`
	static STUDENT_EMAIL_CHANGE_CONFIRM = `/api/private/student/profile/email/confirm`
	static TEACHER_EMAIL_CHANGE_CONFIRM = `/api/private/teacher/profile/email/confirm`

	static COMMON_ME = '/api/private/common/me'
	static COMMON_RESEND_EMAIL = '/api/private/common/resend-email'
	static COMMON_COMPANY_LOG = id => `/api/private/common/company-log/${id}`
	/*
	 * Lebensmittelhygiene und Allergeninformation (Anforderung #96). Eine Route
	 * fuer alle Rollen — wer was darf, entscheidet der Server.
	 */
	static COMMON_COMPANY_HYGIENE = id => `/api/private/common/company-hygiene/${id}`
	static COMMON_COMPANY_HYGIENE_OBJECTION = id => `/api/private/common/company-hygiene/${id}/objection`
	// Ohne Anmeldung nur die Einträge, die Registrierung und öffentliche Seiten
	// brauchen; alles Weitere angemeldet und je Rolle (Backend:
	// services/options/audience.js).
	static COMMON_GET_OPTIONS = '/api/public/options'
	static COMMON_GET_PRIVATE_OPTIONS = '/api/private/common/options'
	static COMMON_GET_STATS = '/api/public/statistic'
	// Woran im oeffentlichen Kurs gemessen wird (Kapitel, Fragen, Huerde)
	static PUBLIC_COURSE = '/api/public/course'
	/*
	 * Die Teilnahmebestätigung zur Lernstrecke — braucht eine Anmeldung, weil sie
	 * auf einen Namen ausgestellt wird. Offen für jede Rolle.
	 *
	 * Heißt „participation" und nicht „certificate": Unter
	 * DOCUMENT_TYPES.COURSE_CERTIFICATE läuft schon der von außerhalb
	 * **hochgeladene** Kursnachweis. Zwei verschiedene Dinge unter einem Namen
	 * wären eine Verwechslung mit Ansage.
	 */
	static COURSE_PARTICIPATION = '/api/private/course/participation'
	static COURSE_PARTICIPATION_DOWNLOAD = '/api/private/course/participation/download'
	// Das Handbuch zur Lernstrecke (PDF von JAA, Anforderung #187): Schüler:innen,
	// Lehrkräfte und Verwaltung, nur angemeldet.
	static COURSE_HANDBOOK = '/api/private/course/handbook'
	/*
	 * Kurse mit Videos (Kursverwaltung, KI-Kurs). Nicht zu verwechseln mit der
	 * Lernstrecke darüber (`/course/…`, Einzahl): Die gehört zu Skills4Retail.
	 */
	static COURSES = '/api/private/courses'
	static COURSE = id => `/api/private/courses/${id}`
	static COURSE_CERTIFICATE = id => `/api/private/courses/${id}/certificate`
	static COURSE_LESSON = id => `/api/private/courses/lessons/${id}`
	static COURSE_LESSON_PROGRESS = id => `/api/private/courses/lessons/${id}/progress`
	static COURSE_QUIZ = moduleId => `/api/private/courses/modules/${moduleId}/quiz`
	static TEACHER_COURSES = '/api/private/teacher/courses'
	static TL_COURSES = '/api/private/courses?anbieter=TL'
	static TL_COURSE_START = id => `/api/private/courses/${id}/tl-start`
	static TEACHER_COURSE_CERTIFICATE = completionId => `/api/private/teacher/courses/certificate/${completionId}`
	static PUBLIC_COURSE_CERTIFICATE = code => `/api/public/course-certificates/${code}`
	static ADMIN_COURSES = '/api/private/admin/courses'
	static ADMIN_COURSE = id => `/api/private/admin/courses/${id}`
	static ADMIN_COURSE_COVER = id => `/api/private/admin/courses/${id}/cover`
	static ADMIN_COURSE_MODULES = id => `/api/private/admin/courses/${id}/modules`
	static ADMIN_COURSE_MODULES_ORDER = id => `/api/private/admin/courses/${id}/modules/order`
	static ADMIN_COURSE_MODULE = moduleId => `/api/private/admin/courses/modules/${moduleId}`
	static ADMIN_COURSE_LESSONS = moduleId => `/api/private/admin/courses/modules/${moduleId}/lessons`
	static ADMIN_COURSE_LESSONS_ORDER = moduleId => `/api/private/admin/courses/modules/${moduleId}/lessons/order`
	static ADMIN_COURSE_LESSON = lessonId => `/api/private/admin/courses/lessons/${lessonId}`
	static ADMIN_COURSE_LESSON_VIDEO = lessonId => `/api/private/admin/courses/lessons/${lessonId}/video`
	// Videos gehen in Stücken zu höchstens 8 MB hinaus: Der Webserver lehnt
	// größere Anfragen ab (413).
	static ADMIN_COURSE_LESSON_VIDEO_CHUNK = lessonId => `/api/private/admin/courses/lessons/${lessonId}/video/chunk`
	static ADMIN_COURSE_LESSON_VIDEO_BUNNY = lessonId => `/api/private/admin/courses/lessons/${lessonId}/video/bunny`
	static ADMIN_COURSE_LESSON_VIDEO_BUNNY_COMPLETE = lessonId => `/api/private/admin/courses/lessons/${lessonId}/video/bunny/complete`
	static ADMIN_COURSES_MEDIA_SETTINGS = '/api/private/admin/courses/media-settings'
	static ADMIN_COURSE_LESSON_THUMBNAIL = lessonId => `/api/private/admin/courses/lessons/${lessonId}/thumbnail`
	static ADMIN_COURSE_QUESTIONS = moduleId => `/api/private/admin/courses/modules/${moduleId}/questions`
	static ADMIN_COURSE_QUESTION = questionId => `/api/private/admin/courses/questions/${questionId}`
	static ADMIN_COURSE_REPORT = '/api/private/admin/course-report'
	static ADMIN_COURSE_REPORT_COMPANY = id => `/api/private/admin/course-report/company/${id}`
	static ADMIN_COURSE_REPORT_EXPORT = '/api/private/admin/course-report/export'
	static ADMIN_COURSE_REPORT_CERTIFICATE = completionId =>
		`/api/private/admin/course-report/certificate/${completionId}`
	static COMMON_GET_COMPANIES = '/api/public/companies'
	static PUBLIC_COMPANY_LOGO = name => `/api/public/companies/logo/${name}`
	static COMMON_GET_SCHOOLS = 'api/public/schools'

	static STUDENT_COMMON_PERSONAL_DETAILS = '/api/private/student/auth/personal-details'
	static STUDENT_COMMON_CREATE_COMPANY = '/api/private/student/auth/create-company'
	static STUDENT_SET_AWAIT_INVITATION = '/api/private/student/auth/set-await-invitation'

	static STUDENT_GET_COMPANY = '/api/private/student/company'
	static STUDENT_GET_COMPANY_SUPERVISION = '/api/private/student/company/supervision'
	static STUDENT_GET_DASHBOARD = '/api/private/student/dashboard'
	static STUDENT_PUT_SET_REVIEW = '/api/private/student/company/review'
	static STUDENT_GET_NEWS = '/api/private/student/news'
	static STUDENT_GET_EMPLOEES = '/api/private/student/employees'
	static STUDENT_GET_INVITED_EMPLOYEES = '/api/private/student/employees/invited'
	static STUDENT_MAKE_CEO = userId => `/api/private/student/users/${userId}`
	static STUDENT_DELETE_EMPLOYEE = userId => `/api/private/student/company/employees/${userId}`

	static STUDENT_GET_DOCUMENTS = '/api/private/student/documents'
	static STUDENT_DOWNLOAD_DOCUMENT = name => `/api/private/student/documents/${name}`

	static STUDENT_GET_SCHOOLS = '/api/private/student/schools'
	static STUDENT_GET_TEACHERS = '/api/private/student/teachers'
	static STUDENT_PUT_PROFILE = '/api/private/student/profile'
	static STUDENT_EXPERTS = '/api/private/student/experts'
	static STUDENT_CHANGE_EXPERTS = id => `/api/private/student/experts/${id}`
	static ADMIN_PUT_PROFILE = '/api/private/admin/profile'
	static ADMIN_EMAIL_CHANGE = `${TApi.ADMIN_PUT_PROFILE}/email`
	static ADMIN_PASSWORD_CHANGE = `${TApi.ADMIN_PUT_PROFILE}/password`
	static ADMIN_AVATAR = `${TApi.ADMIN_PUT_PROFILE}/avatar`
	static ADMIN_EMAIL_CHANGE_CONFIRM = `/api/private/admin/profile/email/confirm`

	static STUDENT_PUT_COMPANY_SUPERVISION = '/api/private/student/company/supervision'
	static STUDENT_POST_INVITE_EMPLOYEE = '/api/private/student/company/employees/invite'
	static STUDENT_POST_UPLOAD_BUSINESS_PLAN = '/api/private/student/documents/business-plan'
	static STUDENT_POST_UPLOAD_FINAL_REPORT = '/api/private/student/documents/final-report'
	static STUDENT_DELETE_INVITE_EMPLOYEE = id => `/api/private/student/company/employees/invite/${id}`
	static STUDENT_RESEND_INVITE = id => `/api/private/student/company/employees/invite/${id}/resend`
	static STUDENT_GET_EMPLOYEES = '/api/private/student/company/employees'
	static STUDENT_PUT_EMPLOYEES = id => `/api/private/student/employees/${id}`
	static STUDENT_LEAVE_COMPANY = '/api/private/student/company/employees/leave'
	static STUDENT_COMPANY_INSURANCE = `/api/private/student/insurance`

	static STUDENT_CONCEPT = '/api/private/student/concept'
	static STUDENT_CONCEPT_FIELD = no => `/api/private/student/concept/fields/${no}`
	static STUDENT_CONCEPT_ASSIGNMENTS = no => `/api/private/student/concept/fields/${no}/assignments`
	static STUDENT_CONCEPT_QUIZ = '/api/private/student/concept/quiz'
	// Den im Browser gemerkten Stand aus dem oeffentlichen Kurs uebernehmen
	static STUDENT_CONCEPT_QUIZ_IMPORT = '/api/private/student/concept/quiz/import'
	static STUDENT_CONCEPT_SUBMIT = '/api/private/student/concept/submit'

	static TEACHER_CONCEPT_LIST = '/api/private/teacher/concept'
	static TEACHER_CONCEPT = id => `/api/private/teacher/concept/${id}`
	static TEACHER_CONCEPT_SCORE = (id, no) => `/api/private/teacher/concept/${id}/fields/${no}/score`
	static TEACHER_CONCEPT_FINISH = id => `/api/private/teacher/concept/${id}/finish`
	static TEACHER_CONCEPT_RETURN = id => `/api/private/teacher/concept/${id}/return`
	static TEACHER_CONCEPT_EXEMPTION = id => `/api/private/teacher/concept/${id}/exemption`

	static STUDENT_POST_INVITE_TEACHER = 'api/private/student/company/teachers/invite'
	static STUDENT_DELETE_INVITE_TEACHER = id => `/api/private/student/company/teachers/invite/${id}`
	static STUDENT_GET_COMPANY_TEACHERS = '/api/private/student/company/teachers'
	static STUDENT_DELETE_COMPANY_TEACHER = id => `/api/private/student/company/teachers/delete/${id}`
	static STUDENT_ADD_TEACHER = 'api/private/student/company/teachers/add'
	static STUDENT_CREATE_SCHOOL = 'api/private/common/schools'

	static STUDENT_GET_SHARES = '/api/private/student/shareholders'
	static STUDENT_DOWNOLOAD_SHARE_CONSENT = name => `/api/private/student/shareholders/${name}`
	static STUDENT_DELETE_SHARE = id => `api/private/student/shareholders/${id}`
	static STUDENT_ADD_SHAREHOLDER = '/api/private/student/shareholders'
	static STUDENT_GET_SHAREHOLDER_COMPANY_TYPE = 'api/private/student/shareholders/companyType'
	static STUDENT_POST_INVOICES = '/api/private/student/invoices'
	static STUDENT_GET_SHAREHOLDER_TEMPLATE = '/api/private/student/shareholders/shareholder-certificate-template'

	static TEACHER_PUT_PROFILE = '/api/private/teacher/profile'
	static TEACHER_PUT_PROFILE_CONTACTS = '/api/private/teacher/profile/contacts'
	static TEACHER_PROFILE_AVATAR = '/api/private/teacher/profile/avatar'
	static TEACHER_COMMON_PERSONAL_DETAILS = '/api/private/teacher/auth/personal-details'

	static TEACHER_GET_SCHOOLS = '/api/private/teacher/schools'
	static TEACHER_PUT_PROFILE_PASSWORD = '/api/private/teacher/profile/password'
	static STUDENT_EMAIL_CHANGE = `${TApi.STUDENT_PUT_PROFILE}/email`
	static STUDENT_PASSWORD_CHANGE = `${TApi.STUDENT_PUT_PROFILE}/password`
	static STUDENT_AVATAR_UPLOAD = `${TApi.STUDENT_PUT_PROFILE}/avatar`
	static STUDENT_AVATAR_DELETE = `${TApi.STUDENT_PUT_PROFILE}/avatar`
	static STUDENT_PARENTAL_CONFIRMATION = `${TApi.STUDENT_PUT_PROFILE}/parental-confirmation`
	static STUDENT_PARENTAL_CONFIRMATION_TEMPLATE = `${TApi.STUDENT_PUT_PROFILE}/parental-confirmation-template`
	static STUDENT_REPORTS = `api/private/student/reports`
	static STUDENT_VERIFY_EMAIL_COMPANY = 'api/private/student/company/verify-email'
	/*
	 * Die Bestaetigung selbst laeuft ueber die oeffentliche Route: Der Link kommt
	 * aus dem Firmenpostfach und wird oft dort geoeffnet, wo niemand angemeldet
	 * ist. Der Nachweis ist der signierte Token im Link.
	 */
	static PUBLIC_COMPANY_VERIFY_EMAIL = token => `/api/public/company/verify-email?token=${encodeURIComponent(token)}`

	static STUDENT_PUT_REPORTS = id => `/api/private/student/reports/${id}`
	// Lag frueher unter dem oeffentlichen Praefix und damit offen: Wer den
	// Dateinamen hatte, kam an das Bild — auch an Fotos minderjaehriger
	// Schueler:innen und auch ohne Zugang zur Anwendung. Seit 01.08.2026
	// angemeldet. Diese Adresse NICHT direkt einem Bild-Element mitgeben: Das
	// schickt keinen Anmelde-Kopfeintrag mit. Dafuer gibt es `UI/AuthAvatar`
	// bzw. `shared/useAvatarUrls`.
	static PROFILE_AVATAR = name => `/api/private/files/avatar/${name}`

	// Frueher `/api/public/files/document/...`. Die Route lag offen: Wer den
	// Dateinamen kannte, kam ohne Anmeldung an Elternbestaetigungen und
	// Kursnachweise. Der Abruf lief hier ohnehin schon ueber `http` und damit
	// mit Anmeldung — es aendert sich nur die Adresse.
	static GET_FILES_DOCUMENT = name => `${API_URL}/api/private/files/document/${name}`

	static ADMIN_GET_FILES_DOCUMENT = name => `${API_URL}/api/private/admin/files/document/${name}`
	static ADMIN_REVIEW_PARENTAL_CONFIRMATION = id => `${API_URL}/api/private/admin/users/students/${id}/reviewed`
	static ADMIN_REJECT_PARENTAL_CONFIRMATION = id => `${API_URL}/api/private/admin/users/students/${id}/reject`
	static ADMIN_ACTIVATE_TEACHER = id => `api/private/admin/users/teachers/activate/${id}`

	static COMMON_GET_NOTIFICATIONS = '/api/private/common/notifications'
	static COMMON_MARK_READ_NOTIFICATIONS = '/api/private/common/notifications'
	static COMMON_ACTIVATED_STATUS = '/api/private/common/status'

	static TEACHER_GET_STUDENTS = '/api/private/teacher/students/all'
	static TEACHER_GET_ASSIGNED_STUDENTS = '/api/private/teacher/students/assigned'
	static TEACHER_GET_TOKEN_STUDENT = id => `/api/private/teacher/students/token/${id}`

	/*
	 * Die Nachweise einer Schueler:in im Profilfenster der Lehrkraft
	 * (Anforderung #94): ansehen, und — wenn die Verwaltung es fuer diese
	 * Unternehmensform freigegeben hat — an ihrer Stelle hochladen.
	 */
	static TEACHER_STUDENT_DOCUMENTS = id => `/api/private/teacher/students/${id}/documents`
	static TEACHER_STUDENT_PARENTAL_CONFIRMATION = id => `/api/private/teacher/students/${id}/parental-confirmation`

	/*
	 * Beanstanden und Entfernen eines Nachweises. POST und nicht DELETE: Die
	 * Begruendung ist Pflicht und muss im Rumpf stehen — der Server liest
	 * DELETE-Rumpfe nicht mit, und in die Adresszeile gehoert sie ohnehin nicht.
	 * `art` ist "parental-confirmation".
	 */
	static TEACHER_STUDENT_DOCUMENT_OBJECTION = (id, art) =>
		`/api/private/teacher/students/${id}/documents/${art}/objection`
	static TEACHER_STUDENT_DOCUMENT_REMOVAL = (id, art) =>
		`/api/private/teacher/students/${id}/documents/${art}/removal`
	//changed mock
	static TEACHER_GET_COMPANIES = '/api/private/teacher/companies/assigned'
	static TEACHER_GET__ASSIGNED_COMPANIES = 'api/private/teacher/companies/assigned'
	static TEACHER_GET_DOCUMENTS = '/api/private/teacher/documents'
	static TEACHER_DOWNLOAD_DOCUMENT = name => `/api/private/teacher/documents/${name}`

	static TEACHER_GET_ALL_COMPANIES = '/api/private/teacher/companies/all'
	static TEACHER_GET_ASSIGNED_COMPANIES = '/api/private/teacher/companies/assigned'
	static TEACHER_ASSIGN_REQUEST = '/api/private/teacher/companies/request'
	/*
	 * Der Stand einer betreuten Junior Company — dasselbe, was die Schüler:innen
	 * auf ihrem Dashboard sehen, nur lesend. Die Firma steht in der Adresse: Eine
	 * Lehrkraft betreut mehrere, und auf dem Dashboard muss klar sein, welche
	 * gerade gemeint ist.
	 */
	static TEACHER_GET_COMPANY_DASHBOARD = id => `/api/private/teacher/companies/${id}/dashboard`
	/*
	 * Das Unternehmensprofil einer betreuten Junior Company — dieselben Angaben
	 * wie im Firmenprofil der Verwaltung, nur lesend und ohne deren internen
	 * Kommentar. Die beiden Abfragen darunter gehören zu zwei Abschnitten darin.
	 */
	static TEACHER_GET_COMPANY_PROFILE = id => `/api/private/teacher/companies/${id}/profile`
	static TEACHER_GET_COMPANY_SHAREHOLDERS = id => `/api/private/teacher/companies/${id}/shareholders`
	static TEACHER_GET_COMPANY_SUPPORTERS = id => `/api/private/teacher/companies/${id}/supporters`
	// Vorlage der Einverständniserklärung für die Schüler:innen einer betreuten
	// Junior Company — dieselbe Vorlage wie im Profil der Schüler:innen (#182).
	static TEACHER_PARENTAL_CONFIRMATION_TEMPLATE = id =>
		`/api/private/teacher/companies/${id}/parental-confirmation-template`
	static STUDENT_ASSIGN_REQUEST_ID = id => `/api/private/student/teachers/request/${id}`
	static STUDENT_ACCEPT_REQUEST = '/api/private/student/teachers/request/accept'

	static RECOVER_PASS = '/api/auth/recover'
	static NEW_PASS = '/api/auth/recover/newpass'

	static TEACHER_GET_DASHBOARD = '/api/private/teacher/dashboard'
	static TEACHER_GET_REPORTS = '/api/private/teacher/reports'

	static COMPANY_PROFILE_UPDATE = `company/profile/update`
	static COMPANY_PUT_PROFILE = '/api/private/student/company'
	static COMPANY_CHANGE_EMAIL_BY_ADMIN = id => `/api/private/admin/company/${id}/email`
	static COMPANY_CHANGE_NAME_BY_ADMIN = id => `/api/private/admin/company/${id}/name`

	static REQUEST_PASSWORD_RESET = '/api/public/auth/forgot-password/request-password-reset'
	static RESET_PASSWORD = '/api/public/auth/forgot-password/reset-password'
	static PASS_NEW_USER = '/api/public/auth/signup/new-user-password'

	static PROFILE_UPDATE = `/profile/update`

	static CREATE_SCHOOL = `/api/private/admin/schools`

	static ADD_SHAREHOLDER = '/company/user/add/shareholder'
	static ADD_EXPERT = '/company/user/add/expert'
	static ADD_TEACHER = '/company/user/add/teacher'
	static ADD_EMPLOYEE = '/company/user/add/employee'

	static CUSTOMIZE_COMPANIES_WIDGET = '/widgets/customize/companies'
	static CUSTOMIZE_INCOME_WIDGET = '/widgets/customize/income'
	static CUSTOMIZE_MULTI_WIDGET = '/widgets/customize/multi'
	static CUSTOMIZE_TABLE_FIELDS = '/widgets/customize/table-fields'

	static TEACHER_GET_NEWS = '/api/private/teacher/news'

	static ADMIN_GET_NEWS = '/api/private/admin/news'
	static ADMIN_POST_NEWS = '/api/private/admin/news'
	static ADMIN_NEWS_RECIPIENTS = '/api/private/admin/news/recipients'
	static ADMIN_NEWS_CHANGES = id => `/api/private/admin/news/${id}/changes`
	static ADMIN_PUT_NEWS = id => `/api/private/admin/news/${id}`
	static ADMIN_DELETE_NEWS = id => `/api/private/admin/news/${id}`
	// Entwurf umschalten, ohne die ganze Nachricht zu schicken (#164).
	static ADMIN_NEWS_DRAFT = id => `/api/private/admin/news/${id}/draft`

	// Oben anheften — nur fuer Bundesadmins (Anforderung #164).
	static ADMIN_NEWS_PIN = id => `/api/private/admin/news/${id}/pin`
	// Titelbild einer Nachricht — eigener Weg, weil das Bild als Datei kommt
	// und der Rest des Formulars als JSON.
	static ADMIN_NEWS_IMAGE = id => `/api/private/admin/news/${id}/image`

	// Kommunikation: E-Mail-Vorlagen und interne Nachrichten
	static ADMIN_COMM_OVERVIEW = '/api/private/admin/communication/overview'
	static ADMIN_COMM_EMAILS = '/api/private/admin/communication/emails'
	static ADMIN_COMM_EMAIL = key => `/api/private/admin/communication/emails/${key}`
	static ADMIN_COMM_EMAIL_PREVIEW = key => `/api/private/admin/communication/emails/${key}/preview`
	static ADMIN_COMM_INTERNAL = '/api/private/admin/communication/internal'
	static ADMIN_COMM_INTERNAL_ITEM = key => `/api/private/admin/communication/internal/${key}`
	// Dokumentvorlagen (PDF): Liste, Beispieldatensätze, Live-Render
	static ADMIN_COMM_DOCUMENTS = '/api/private/admin/communication/documents'
	static ADMIN_COMM_DOCUMENT_SAMPLES = key => `/api/private/admin/communication/documents/${key}/samples`
	static ADMIN_COMM_DOCUMENT_RENDER = (key, recordId) =>
		`/api/private/admin/communication/documents/${key}/render/${recordId}`

	static ADMIN_GET_SCHOOLS = '/api/private/admin/schools'
	static ADMIN_PUT_SCHOOLS_MERGE = '/api/private/admin/schools/merge'
	static ADMIN_PUT_TEACHERS_MERGE = '/api/private/admin/users/teachers/merge'
	static ADMIN_SCHOOL_ID = id => `api/private/admin/schools/${id}`
	static ADMIN_SCHOOL_VERIFY = id => `api/private/admin/schools/${id}/verify`
	static ADMIN_GET_COMPANY = id => `/api/private/admin/company/${id}`
	static ADMIN_GET_COMPANY_PROFILE = id => `/api/private/admin/company/profile/${id}`
	// Geschäftstätigkeit nach der Aktivierung ändern (#230): erst die Folgen
	// abfragen, dann speichern; dazu die Freigabe für die Schüler:innen.
	static ADMIN_COMPANY_BUSINESS_PREVIEW = id => `/api/private/admin/company/${id}/business/preview`
	static ADMIN_COMPANY_BUSINESS = id => `/api/private/admin/company/${id}/business`
	static ADMIN_COMPANY_REVISION_RELEASE = id => `/api/private/admin/company/${id}/revision-release`
	static ADMIN_GET_COMPANIES = '/api/private/admin/companies/'
	static ADMIN_DELETE_COMPANY = id => `/api/private/admin/companies/${id}`
	static ADMIN_DOWNOLOAD_COMPANIES_LIST = '/api/private/admin/companies/downoload/list'
	static ADMIN_DOWNLOAD_COMPANY_DATA = id => `/api/private/admin/companies/download/${id}`
	static ADMIN_GET_TEACHERS = '/api/private/admin/users/teachers'
	static ADMIN_PUT_COMPANY_COMMENT = id => `api/private/admin/company/${id}/comment`
	static ADMIN_PUT_COMPANY_ACTIVATION = id => `api/private/admin/company/${id}/activation`
	static ADMIN_PUT_REGENERATE_COMPANY_CERTIFICATE = id => `api/private/admin/company/${id}/regenerate`
	static ADMIN_PUT_COMPANY_REJECT = id => `api/private/admin/company/${id}/reject`
	static ADMIN_EXPERTS = '/api/private/admin/experts'
	static ADMIN_EXPERT_ID = id => `/api/private/admin/experts/${id}`
	static ADMIN_CONFIRM_EXPERT = id => `/api/private/admin/experts/confirm/${id}`
	static ADMIN_UNCONFIRM_EXPERT = id => `/api/private/admin/experts/unconfirm/${id}`
	static ADMIN_RESEND_EMAIL_EXPERT = id => `/api/private/admin/experts/resend/${id}`

	// --- Unterstuetzer:innen ---
	// Anforderungen
	static ADMIN_TICKETS = '/api/private/admin/tickets'
	// Der Hilfe-Knopf: der Weg der Endnutzer:innen (Anfragen-Konzept, Stufe 2).
	static ADMIN_TICKET_REQUEST_STATS = '/api/private/admin/tickets/request-stats'
	static REQUESTS = '/api/private/requests'
	static REQUEST_ATTACHMENTS = id => `/api/private/requests/${id}/attachments`

	// Auswertung zum Skills4Retail-Konzept (Ueberblick, Liste, Excel-Ausgabe).
	static ADMIN_CONCEPT_OVERVIEW = '/api/private/admin/concept-report/overview'
	static ADMIN_CONCEPT_STUDENTS = '/api/private/admin/concept-report/students'
	static ADMIN_CONCEPT_DOWNLOAD = '/api/private/admin/concept-report/students/download'
	static ADMIN_CONCEPT_COMPANY = id => `/api/private/admin/concept-report/company/${id}`
	static ADMIN_CONCEPT_COMPANY_PDF = id => `/api/private/admin/concept-report/company/${id}/pdf`
	static ADMIN_TICKET_BULK = '/api/private/admin/tickets/bulk'
	static ADMIN_TICKET_ID = id => `/api/private/admin/tickets/${id}`
	static ADMIN_TICKET_SCREENSHOTS = id => `/api/private/admin/tickets/${id}/screenshots`
	static ADMIN_TICKET_SCREENSHOT_ID = (id, shotId) => `/api/private/admin/tickets/${id}/screenshots/${shotId}`
	static ADMIN_TICKET_SCREENSHOT_FILE = (id, shotId) => `/api/private/admin/tickets/${id}/screenshots/${shotId}/file`
	static ADMIN_TICKET_COMMENTS = id => `/api/private/admin/tickets/${id}/comments`
	static ADMIN_TICKET_COMMENT_ID = (id, commentId) => `/api/private/admin/tickets/${id}/comments/${commentId}`
	static ADMIN_TICKET_PROJECTS = '/api/private/admin/tickets/projects'
	static ADMIN_TICKET_PROJECT_ID = id => `/api/private/admin/tickets/projects/${id}`
	// Konten, denen sich eine Anforderung zuweisen laesst (nur die Administration).
	static ADMIN_TICKET_ASSIGNEES = '/api/private/admin/tickets/assignees'
	// Offene Anforderungen je Reiter: { all, assigned, mine }
	static ADMIN_TICKET_COUNTS = '/api/private/admin/tickets/counts'

	// Aenderungsliste
	static ADMIN_CHANGELOG = '/api/private/admin/changelog'
	static ADMIN_ANNUAL_REPORT = '/api/private/admin/annual-report'
	static ADMIN_ANNUAL_REPORT_PDF = '/api/private/admin/annual-report/pdf'

	/*
	 * Die offenen Fassungen. Anders als beim Admin-Bericht sind das **volle
	 * Adressen** samt API_URL: Sie werden nicht abgerufen, sondern in ein
	 * `<iframe src>` und einen Download-Verweis geschrieben. Beides laedt ohne
	 * die Kopfzeile mit dem Zugang - was bei einer geschuetzten Route ein 401
	 * waere und hier gerade der Punkt ist.
	 */
	static PUBLIC_REPORT = bericht => `${API_URL}/api/public/reports/${bericht}`
	static PUBLIC_REPORT_PDF = bericht => `${API_URL}/api/public/reports/${bericht}/pdf`
	static ADMIN_CHANGELOG_ID = id => `/api/private/admin/changelog/${id}`
	static ADMIN_CHANGELOG_FACETS = '/api/private/admin/changelog/facets'
	static ADMIN_CHANGELOG_STATS = '/api/private/admin/changelog/stats'

	static ADMIN_SUPPORTERS = '/api/private/admin/supporters'
	static ADMIN_SUPPORTER_ID = id => `/api/private/admin/supporters/${id}`
	static ADMIN_SUPPORTER_STATUS = id => `/api/private/admin/supporters/${id}/status`
	static ADMIN_SUPPORTER_APPROVE = id => `/api/private/admin/supporters/${id}/approve`
	static ADMIN_SUPPORTER_LOOKUPS = '/api/private/admin/supporters/lookups'
	static ADMIN_SUPPORTER_LOG = id => `/api/private/admin/supporters/${id}/log`
	static ADMIN_SUPPORTER_SUPPORT_REQUESTS = id => `/api/private/admin/supporters/${id}/support-requests`
	static ADMIN_SUPPORT_REQUESTS = '/api/private/admin/support-requests'
	static ADMIN_SUPPORT_REQUEST_ID = id => `/api/private/admin/support-requests/${id}`
	static ADMIN_SUPPORT_REQUEST_CHANGES = id => `/api/private/admin/support-requests/${id}/changes`
	static ADMIN_SUPPORT_REQUEST_NOTIFY = id => `/api/private/admin/support-requests/${id}/notify`
	static ADMIN_SUPPORT_REQUEST_REACH = '/api/private/admin/support-requests/recipients/count'
	static ADMIN_SUPPORT_CATEGORIES = '/api/private/admin/support-requests/categories'
	static ADMIN_SUPPORT_CATEGORIES_USAGE = '/api/private/admin/support-requests/categories/usage'
	static ADMIN_SUPPORTER_LOOKUP_LIST = type => `/api/private/admin/supporter-lookups/${type}`
	static ADMIN_SUPPORTER_LOOKUP_ITEM = (type, id) => `/api/private/admin/supporter-lookups/${type}/${id}`
	static ADMIN_SUPPORTER_DOWNLOAD = '/api/private/admin/supporters/download/list'
	static ADMIN_SUPPORTER_INVITATIONS = '/api/private/admin/supporters/invitations'
	static ADMIN_SUPPORTER_INVITATION_IMPACT = '/api/private/admin/supporters/invitations/impact'
	static ADMIN_SUPPORTER_INVITATION_RESEND = id => `/api/private/admin/supporters/invitations/${id}/resend`
	static ADMIN_SUPPORTER_INVITATION_ID = id => `/api/private/admin/supporters/invitations/${id}`

	// Self-Service der Unterstuetzer:innen
	static SUPPORTER_PROFILE = '/api/private/supporter/profile'
	static SUPPORTER_AVAILABILITY = '/api/private/supporter/profile/availability'
	static SUPPORTER_AVATAR = '/api/private/supporter/profile/avatar'
	static SUPPORTER_LOOKUPS = '/api/private/supporter/lookups'
	static SUPPORTER_OFFERS = '/api/private/supporter/offers'
	static SUPPORTER_OFFER_ID = id => `/api/private/supporter/offers/${id}`
	static SUPPORTER_CONNECTIONS = '/api/private/supporter/connections'
	static SUPPORTER_SUPPORT_REQUESTS = '/api/private/supporter/support-requests'
	static SUPPORTER_SUPPORT_REQUEST_ID = id => `/api/private/supporter/support-requests/${id}`
	static SUPPORTER_CONNECTION_ID = id => `/api/private/supporter/connections/${id}`
	static SUPPORTER_LOG = '/api/private/supporter/log'

	// Sicht der Schulen (Lehrkraefte + Schueler:innen)
	static COMMON_SUPPORTERS = '/api/private/common/supporters'
	static COMMON_SUPPORTER_ID = id => `/api/private/common/supporters/${id}`
	static COMMON_SUPPORTER_REQUEST = id => `/api/private/common/supporters/${id}/request`
	// Antwort auf die Rückfrage nach der Kontaktaufnahme (#232)
	static COMMON_SUPPORTER_CONTACT_CHECK = connectionId =>
		`/api/private/common/supporters/connections/${connectionId}/contact-check`
	static COMMON_SUPPORTER_END = id => `/api/private/common/supporters/${id}/end`
	static COMMON_SUPPORTER_LOOKUPS = '/api/private/common/supporters/lookups'
	// Eine Expert:in selbst einladen (Schüler:innen und Lehrkräfte).
	static COMMON_SUPPORTER_INVITE = '/api/private/common/supporters/invite'
	// Offene Einladungen der eigenen Junior Company (#248)
	static COMMON_SUPPORTER_INVITATIONS = '/api/private/common/supporters/invitations'
	static COMMON_SUPPORTER_INVITATION = id => `/api/private/common/supporters/invitations/${id}`
	static COMMON_SUPPORTER_INVITATION_RESEND = id => `/api/private/common/supporters/invitations/${id}/resend`
	/*
	 * Verlauf und Anmerkungen der eigenen Junior Company zu dieser Expert:in.
	 * Die Firma steht in der Adresse: Eine Lehrkraft betreut mehrere, und der
	 * Verlauf gehört immer genau einer davon.
	 */
	static COMMON_SUPPORTER_LOG = (id, companyId) => `/api/private/common/supporters/${id}/log/${companyId}`

	// Oeffentlich: Einladung und Selbstregistrierung
	static PUBLIC_SUPPORTER_INVITATION = token => `/api/public/supporters/invitation/${token}`
	static PUBLIC_SUPPORTER_ACTIVATE = '/api/public/supporters/activate'
	static PUBLIC_SUPPORTER_REGISTER = '/api/public/supporters/register'

	static ADMIN_GET_LIST_DOCUMENTS = '/api/private/admin/documents'
	static ADMIN_DOCUMENTS_EXPORT_EXCEL = '/api/private/admin/documents/export/excel'
	static ADMIN_DOCUMENTS_EXPORT_ZIP = '/api/private/admin/documents/export/zip'

	static ADMIN_UPDATE_WIDGET_SETTINGS = '/api/private/admin/widgets/settings'
	static ADMIN_WIDGET_GET_COMPANIES_PENDING = '/api/private/admin/widgets/companies-pending'
	static ADMIN_WIDGET_GET_INVOICES_OVERDUE = '/api/private/admin/widgets/invoices-overdue'
	static ADMIN_WIDGET_GET_COMPANIES = '/api/private/admin/widgets/companies'
	static ADMIN_WIDGET_GET_STUDENTS = '/api/private/admin/widgets/students'
	static ADMIN_WIDGET_GET_REPORTS = '/api/private/admin/widgets/reports'
	static ADMIN_WIDGET_GET_REPORTS_DATA = '/api/private/admin/widgets/reports-data'
	static ADMIN_WIDGET_GET_TEACHERS = '/api/private/admin/widgets/teachers'
	static ADMIN_WIDGET_GET_TURNOVERS = '/api/private/admin/widgets/turnovers'
	static ADMIN_WIDGET_GET_INVOICES = '/api/private/admin/widgets/invoices'
	static ADMIN_WIDGET_GET_MULTI = '/api/private/admin/widgets/multi'
	static ADMIN_STATE_ADMINS = '/api/private/admin/state-admins'
	// Erinnerungen per E-Mail eines Verwaltungskontos (Profil und Administration)
	static ADMIN_REMINDER_SETTINGS = id => `/api/private/admin/reminder-settings/${id}`
	static ADMIN_STATE_ADMINS_ID = id => `/api/private/admin/state-admins/${id}`
	static ADMIN_GET_USERS = '/api/private/admin/users'
	static ADMIN_DOWNOLOAD_USERS_LIST = '/api/private/admin/users/downoload/list'
	static ADMIN_GET_INVOICES = '/api/private/admin/invoices'
	static ADMIN_DOWNOLOAD_INVOICES_LIST = '/api/private/admin/invoices/downoload/list'
	static ADMIN_GET_REPORTS = '/api/private/admin/reports'
	static ADMIN_DOWNOLOAD_REPORTS_LIST = '/api/private/admin/reports/downoload/list'
	static ADMIN_GET_REPORT = id => `/api/private/admin/reports/${id}`
	static ADMIN_DOWNLOAD_REPORT = id => `/api/private/admin/reports/download/calculation/${id}`
	static TEACHER_GET_REPORT = id => `/api/private/teacher/reports/${id}`
	static TEACHER_DOWNOLOAD_REPORTS_LIST = '/api/private/teacher/reports/downoload/list'
	static ADMIN_DOWNOLOAD_REPORTS_XLS = '/api/private/admin/reports/downoload/xls'
	static ADMIN_UNSUBMIT_REPORTS = id => `/api/private/admin/reports/delete/${id}`
	static ADMIN_PUT_INVOICES = id => `/api/private/admin/invoices/${id}`
	static ADMIN_CANCEL_INVOICE = id => `/api/private/admin/invoices/${id}/cancel`
	static ADMIN_DOWNLOAD_INVOICES = id => `api/private/admin/invoices/download/${id}`
	static ADMIN_DOWNLOAD_DOCUMENT = name => `/api/private/admin/documents/${name}`
	// Die Anteilseigner:innen einer Junior Company — Abschnitt im Firmenprofil.
	static ADMIN_GET_COMPANY_SHAREHOLDERS = companyId => `/api/private/admin/shareholders/company/${companyId}`
	static ADMIN_OPTIONS = 'api/private/admin/options/'
	static ADMIN_TRAINING = '/api/private/admin/training'
	// Der Verlauf der Einstellungsaenderungen: wer, wann, wovon, worauf — und
	// was die Anwendung daraufhin fuer die bestehenden Junior Companies getan hat.
	static ADMIN_OPTION_CHANGES = 'api/private/admin/options/changes'
	// Das Testfenster des E-Mail-Versands: PUT oeffnet es (mit einer Sekundenzahl),
	// DELETE schliesst es vorzeitig. Eigene Route, weil der Endzeitpunkt vom
	// Server kommen muss und nicht von der Uhr dieses Rechners.
	static ADMIN_EMAIL_TEST = 'api/private/admin/options/email-test'
	static ADMIN_GET_DASHBOARD = 'api/private/admin/dashboard'
	static ADMIN_PUT_USER = id => `api/private/admin/users/${id}`
	static ADMIN_CLEAR_DB = '/api/private/admin/clear/'
	static ADMIN_DOWNLOAD_ANONIMIZED_FILE = '/api/private/admin/clear/download'

	static ADMIN_GET_DOCUMENTS = 'api/private/admin/files/documents'
	static ADMIN_GET_PARENTAL = id => `api/private/admin/files/document/${id}`
	static ADMIN_DOWNOLOAD_SCHOOLS_LIST = '/api/private/admin/schools/downoload/list'
	static ADMIN_DOWNOLOAD_EXPERTS_LIST = '/api/private/admin/experts/downoload/list'
	static ADMIN_GET_COMPANY_TEACHERS = id => `/api/private/admin/company/${id}/teachers`
	// Unterstuetzer:innen aus der Sicht einer Junior Company (Reiter „Weg zur
	// Expert:in"): dieselbe Auswahl wie auf der Schulseite, nur lesend.
	static ADMIN_GET_COMPANY_SUPPORTERS = id => `/api/private/admin/company/${id}/supporters`
	static ADMIN_ADD_TEACHER = `/api/private/admin/company/teachers/add`
	static ADMIN_INVITE_TEACHER = `/api/private/admin/company/teachers/invite`
	static ADMIN_DELETE_COMPANY_TEACHER = (companyId, teacherId) =>
		`/api/private/admin/company/teachers/${companyId}/${teacherId}`
	static ADMIN_GET_TOKEN_USER = id => `/api/private/admin/users/token/${id}`
	// Konto einer Schüler:in löschen (Anforderung #226): erst die Vorschau (was
	// mitginge, Sperren, Hinweise — ändert nichts), dann das Löschen selbst.
	static ADMIN_STUDENT_REMOVAL_PREVIEW = id => `/api/private/admin/users/students/${id}/removal`
	static ADMIN_REMOVE_STUDENT = id => `/api/private/admin/users/students/${id}`
	// Dasselbe für Lehrkräfte (Anforderung #239).
	static ADMIN_TEACHER_REMOVAL_PREVIEW = id => `/api/private/admin/users/teachers/${id}/removal`
	static ADMIN_REMOVE_TEACHER = id => `/api/private/admin/users/teachers/${id}`
	// Unterlagen, die die Verwaltung im Firmenprofil nachtragen kann. Der
	// Firmenbuchauszug fehlt hier bewusst: den erzeugt die Aktivierung.
	static ADMIN_COMPANY_LOG = id => `/api/private/admin/company/${id}/log`
	// Junior Mini Company (Anforderung #92)
	static TEACHER_MINI_COMPANIES = '/api/private/teacher/mini-companies'
	static TEACHER_MINI_COMPANIES_ELIGIBILITY = '/api/private/teacher/mini-companies/eligibility'
	static TEACHER_MINI_COMPANY = id => `/api/private/teacher/mini-companies/${id}`
	static TEACHER_MINI_COMPANY_CLASS_ROLE = id => `/api/private/teacher/mini-companies/${id}/class-role`
	static TEACHER_MINI_COMPANY_LOG = id => `/api/private/teacher/mini-companies/${id}/log`
	static TEACHER_MINI_COMPANY_PARTICIPANTS = id => `/api/private/teacher/mini-companies/${id}/participants`
	static TEACHER_MINI_COMPANY_PARTICIPANT = (id, participantId) =>
		`/api/private/teacher/mini-companies/${id}/participants/${participantId}`
	static TEACHER_MINI_COMPANY_CONSENT = id => `/api/private/teacher/mini-companies/${id}/consent`
	static TEACHER_MINI_COMPANY_SUBMIT = id => `/api/private/teacher/mini-companies/${id}/submit`
	static TEACHER_MINI_COMPANY_TEACHERS = id => `/api/private/teacher/mini-companies/${id}/teachers`
	static TEACHER_MINI_COMPANY_TEACHER = (id, teacherId) =>
		`/api/private/teacher/mini-companies/${id}/teachers/${teacherId}`
	static TEACHER_MINI_COMPANY_INVITATION = (id, invitationId) =>
		`/api/private/teacher/mini-companies/${id}/invitations/${invitationId}`
	static TEACHER_MINI_COMPANY_CERTIFICATES = id => `/api/private/teacher/mini-companies/${id}/certificates`
	static ADMIN_MINI_COMPANIES = '/api/private/admin/mini-companies'
	// Kacheln über der Unternehmensliste: je Unternehmensform drei Stufen (#92)
	static ADMIN_COMPANIES_TYPE_COUNTS = '/api/private/admin/companies/type-counts'
	static ADMIN_MINI_COMPANY = id => `/api/private/admin/mini-companies/${id}`
	static ADMIN_MINI_COMPANY_CONSENT = id => `/api/private/admin/mini-companies/${id}/consent`
	static ADMIN_MINI_COMPANY_CERTIFICATES = id => `/api/private/admin/mini-companies/${id}/certificates`
	static ADMIN_MINI_COMPANY_APPROVE = id => `/api/private/admin/mini-companies/${id}/approve`
	static ADMIN_MINI_COMPANY_REJECT = id => `/api/private/admin/mini-companies/${id}/reject`
	static ADMIN_UPLOAD_COMPANY_BUSINESS_PLAN = id => `/api/private/admin/company/${id}/business-plan`
	static ADMIN_UPLOAD_COMPANY_FINAL_REPORT = id => `/api/private/admin/company/${id}/final-report`
	// Kommentare und Ereignisse zu einem beliebigen Datensatz — eine Route für
	// alle Arten (siehe UI/RecordComments und RECORD_TYPES).
	static ADMIN_RECORD_LOG = (entityType, entityId) =>
		`/api/private/admin/record-log/${entityType}/${encodeURIComponent(entityId)}`
}

/**
 * Die Datensatzarten, zu denen es einen Reiter „Kommentare" gibt. Die Wörter
 * stehen genauso im Backend (`services/recordLog`) — wer hier eines ändert,
 * ändert es dort mit.
 */
export const RECORD_TYPES = {
	SCHOOL: 'SCHOOL',
	USER: 'USER',
	INVOICE: 'INVOICE',
	REPORT: 'REPORT',
	EXPERT: 'EXPERT',
	NEWS: 'NEWS',
	TEMPLATE: 'TEMPLATE',
	SUPPORT_REQUEST: 'SUPPORT_REQUEST',
	/*
	 * Die Zusammenarbeit einer Junior Company mit einer Expert:in — der einzige
	 * Verlauf, den nicht die Verwaltung führt, sondern die Schule selbst.
	 * Er läuft deshalb über `COMMON_SUPPORTER_LOG` statt über die Admin-Route.
	 */
	SUPPORTER_COMPANY: 'SUPPORTER_COMPANY'
}
export const INVITATION_TYPE = 'INVITATION_TYPE'

export class TRoles {
	static STUDENT = 'STUDENT'
	static TEACHER = 'TEACHER'
	static ADMIN = 'ADMINISTRATOR'
	static FEDERAL_ADMIN = 'FEDERAL_ADMINISTRATOR'
	static SUPPORTER = 'SUPPORTER'
	// Nur-Lese-Zugang für JA Alumni Austria (Anforderung #213) — siehe shared/alumni.js
	static ALUMNI = 'ALUMNI'
}

/*
 * Die Rolle in den Wörtern der Oberfläche.
 *
 * Eine Stelle für alle Ansichten, in denen Personen verschiedener Rollen
 * nebeneinander stehen — die Anforderungen und Anfragen sind der Anlass: Dort
 * schreiben Schüler:innen, Lehrkräfte, Unterstützer:innen und die Verwaltung in
 * denselben Verlauf, und ein Name allein sagt nicht, wer da schreibt.
 *
 * Dieselben Wörter wie im Einladungsfenster der Unterstützer:innen
 * (`invitedByRole*` in der Übersetzung). Bewusst nicht über i18n: Die
 * Anforderungsverwaltung ist durchgehend deutsch geschrieben, und ein fehlender
 * Schlüssel zeigte hier den Rohwert „FEDERAL_ADMINISTRATOR".
 */
export const RoleLabels = {
	[TRoles.STUDENT]: 'Schüler:in',
	[TRoles.TEACHER]: 'Lehrkraft',
	[TRoles.ADMIN]: 'Landesadmin',
	[TRoles.FEDERAL_ADMIN]: 'Bundesadmin',
	[TRoles.SUPPORTER]: 'Unterstützer:in',
	[TRoles.ALUMNI]: 'Alumni'
}

/*
 * Gehört die Rolle zur Verwaltung? Das Schild neben dem Namen trägt danach
 * seine Farbe: Wer von außen schreibt, ist die Person, auf deren Antwort jemand
 * wartet — die eigene Mannschaft ist die ruhigere Farbe wert.
 */
export const ADMIN_ROLES = [TRoles.ADMIN, TRoles.FEDERAL_ADMIN, TRoles.ALUMNI]

/*
 * Wer die Ansichten der Verwaltung betritt. Alumni (#213) gehören dazu, sehen
 * aber nur einen Teil davon und nur lesend — welche Seiten, steht in
 * `shared/alumni.js`. Die Liste ist bewusst getrennt von `ADMIN_ROLES` oben
 * (Farbe am Namensschild), auch wenn sie heute gleich lautet.
 */
export const ADMIN_AREA_ROLES = [TRoles.ADMIN, TRoles.FEDERAL_ADMIN, TRoles.ALUMNI]

// Sub-Rollen einer Unterstuetzer:in. Eine Person kann mehrere gleichzeitig
// innehaben - deshalb Mehrfachauswahl statt einer einzelnen Rolle.
export class TSupporterRoles {
	static EXPERT = 'EXPERT'
	static JURY = 'JURY'
	static TRAINER = 'TRAINER'
}

export class TSupporterStatus {
	static INVITED = 'INVITED'
	static PENDING_APPROVAL = 'PENDING_APPROVAL'
	static ACTIVE = 'ACTIVE'
	static UNAVAILABLE = 'UNAVAILABLE'
	static ARCHIVED = 'ARCHIVED'
	static DELETED = 'DELETED'
}

export class TTicketType {
	static ISSUE = 'ISSUE'
	static CR = 'CR'
	static DECISION = 'DECISION'
	static OTHER = 'OTHER'
}

/*
 * Woher eine Anforderung kommt.
 *
 * INTERNAL und ENDUSER sind die beiden Werte, die am Datensatz stehen; die drei
 * Rollen daneben sind die Aufschlüsselung dessen, was über den Hilfe-Knopf
 * hereinkam — gelesen aus `context.role`, also aus der Rolle **beim Melden**.
 * „Andere" ist alles Übrige über denselben Weg, eine Landesadministration etwa.
 */
export class TTicketOrigin {
	static INTERNAL = 'INTERNAL'
	static ENDUSER = 'ENDUSER'
	static STUDENT = 'STUDENT'
	static TEACHER = 'TEACHER'
	static SUPPORTER = 'SUPPORTER'
	static OTHER = 'OTHER'
}

/*
 * Die Gruppen der Herkunftsleiste, in der Reihenfolge, in der sie dort stehen.
 * Die Wörter sind die der Oberfläche: „Schüler:innen", nicht „STUDENT".
 */
export const TicketOriginOptions = [
	{ value: TTicketOrigin.STUDENT, label: 'Schüler:innen' },
	{ value: TTicketOrigin.TEACHER, label: 'Lehrkräfte' },
	{ value: TTicketOrigin.SUPPORTER, label: 'Unterstützer:innen' },
	{ value: TTicketOrigin.OTHER, label: 'Andere' }
]

export class TTicketStatus {
	static NEW = 'NEW'
	static CLARIFICATION = 'CLARIFICATION'
	static READY = 'READY'
	static IN_DEVELOPMENT = 'IN_DEVELOPMENT'
	static REVIEW = 'REVIEW'
	static ACCEPTED = 'ACCEPTED'
	static REJECTED = 'REJECTED'
}

/*
 * Die Art steht in beiden Fenstern an erster Stelle: Sie entscheidet, worum es
 * überhaupt geht — und **nur** das. Bis 22.08.2026 stand hier auch „Aufgabe";
 * das war keine Art, sondern die Zuweisung, und es fehlte der Wert, den ein
 * Viertel des Bestands braucht: die Entscheidung, die JAA treffen muss.
 *
 * Kurze Wörter, weil sie in der Spalte „Art" untereinander stehen. Die
 * gespeicherten Werte (ISSUE, CR) bleiben, wie sie sind.
 */
export const TicketTypeOptions = [
	{ value: TTicketType.ISSUE, label: 'Fehler' },
	{ value: TTicketType.CR, label: 'Wunsch' },
	{ value: TTicketType.DECISION, label: 'Entscheidung' },
	{ value: TTicketType.OTHER, label: 'Sonstiges' }
]

/*
 * Dieselben Arten in der Sprache der Endnutzer:innen — der Hilfe-Knopf fragt
 * „Worum geht es?", nicht nach einer Kategorie.
 *
 * **Erst das Wort, dann die Erklärung.** „Ich wünsche mir etwas" klang wie ein
 * Wunschzettel; die Antwort auf eine Meldung ist aber Arbeit und keine
 * Gefälligkeit. Das führende Substantiv benennt den Vorgang so, wie ihn auch
 * die Verwaltung nennt, der Halbsatz dahinter sagt in Alltagssprache, was
 * gemeint ist — für eine Fünfzehnjährige genauso lesbar wie für eine
 * Landesadministratorin.
 *
 * „Entscheidung" fehlt bewusst: Das ist ein interner Wert, den die Verwaltung
 * beim Sichten vergibt. Wer meldet, weiß nicht, ob daraus eine Entscheidung
 * wird. Muss zu OFFENE_ARTEN im Backend passen (api/private/requests/schema).
 */
export const RequestTypeOptions = [
	{ value: TTicketType.ISSUE, labelKey: 'Fehlerbehebung — etwas funktioniert nicht' },
	{ value: TTicketType.CR, labelKey: 'Anpassungsbedarf — etwas sollte anders sein' },
	{ value: TTicketType.OTHER, labelKey: 'Klärungsbedarf — etwas ist unklar' }
]

/*
 * Themen mit eigener Zuständigkeit (Anforderung #216). Kein vierter Wert der
 * Art: Eine Skills4Retail-Anfrage geht als „Klärungsbedarf" hinaus, mit dem
 * Thema daneben — der Server weist sie der Person aus Einstellungen →
 * Anfragen zu. Welche Themen eine Rolle sieht, sagt der Server
 * (`profile.requestTopics`); hier steht nur, wie sie heißen.
 */
export const TRequestTopic = {
	SKILLS4RETAIL: 'SKILLS4RETAIL'
}

export const RequestTopicOptions = [
	{
		value: TRequestTopic.SKILLS4RETAIL,
		labelKey: 'Skills4Retail — Fragen zum Konzept und zur Lernstrecke'
	}
]

/*
 * Reihenfolge = Ablauf. Die Oberfläche zeigt die Auswahl in genau dieser
 * Folge; "Verworfen" steht am Ende, weil eine Anforderung aus jedem Zustand
 * heraus dort landen kann.
 */
/*
 * Dringlichkeit und Wichtigkeit in je drei Stufen. Der Score ist ihr Produkt
 * und liegt damit zwischen 1 und 9.
 */
export const TicketUrgencyOptions = [
	{ value: 1, label: 'weniger dringend' },
	{ value: 2, label: 'dringend' },
	{ value: 3, label: 'sehr dringend' }
]

export const TicketImportanceOptions = [
	{ value: 1, label: 'weniger wichtig' },
	{ value: 2, label: 'wichtig' },
	{ value: 3, label: 'sehr wichtig' }
]

// Groesse und erlaubte Typen fuer Anhaenge. Muss zu den Werten im Backend
// passen (utils/types.js) - dort wird es noch einmal geprueft.
export const TICKET_ATTACHMENT_MAX_MB = 5
export const TICKET_ATTACHMENT_ACCEPT =
	'image/png,image/jpeg,image/gif,image/webp,application/pdf,video/mp4,video/quicktime'

/*
 * Am Kommentar ist weniger erlaubt als an der Anforderung: ein Bildschirmfoto
 * oder ein PDF als Beleg zur Rückfrage — keine Videos. Muss zu
 * TICKET_COMMENT_ATTACHMENT_TYPES im Backend passen, dort wird es noch einmal
 * geprüft.
 */
export const TICKET_COMMENT_ATTACHMENT_ACCEPT = 'image/png,image/jpeg,application/pdf'
export const TICKET_COMMENT_ATTACHMENT_MAX = 5

/*
 * **Eine** Kette für alle Arten, sieben Stufen.
 *
 * Bis 22.08.2026 gab es zwei Ketten mit zwei Sätzen Wörter für dieselben
 * gespeicherten Werte — das kostete eine Umschlüsselung bei jedem Artwechsel
 * und einen Funnel, der je nach Sicht etwas anderes zeigte. „Live" ist
 * entfallen: Kein einziger von 80 Datensätzen trug ihn, und was ausgeliefert
 * wurde, steht in der Änderungsliste.
 *
 * Muss zu TICKET_STATUS/TICKET_STATUS_LABELS im Backend passen.
 */
export const TicketStatusOptions = [
	{ value: TTicketStatus.NEW, label: 'Neu' },
	{ value: TTicketStatus.CLARIFICATION, label: 'Klärung offen' },
	{ value: TTicketStatus.READY, label: 'Eingeplant' },
	{ value: TTicketStatus.IN_DEVELOPMENT, label: 'In Arbeit' },
	{ value: TTicketStatus.REVIEW, label: 'Zur Bestätigung' },
	{ value: TTicketStatus.ACCEPTED, label: 'Abgeschlossen' },
	{ value: TTicketStatus.REJECTED, label: 'Verworfen' }
]

/*
 * Was als offen zählt: alles bis einschließlich „Zur Bestätigung". Dieselbe
 * Abgrenzung wie TICKET_OPEN_STATUS im Backend — sie steht an den Reiterzahlen,
 * in der Erinnerung und in der Mitte des Rings.
 */
export const TicketOpenStatus = [
	TTicketStatus.NEW,
	TTicketStatus.CLARIFICATION,
	TTicketStatus.READY,
	TTicketStatus.IN_DEVELOPMENT,
	TTicketStatus.REVIEW
]

/*
 * Bis 22.08.2026 standen hier `ticketStatusOptions(type)`,
 * `TicketSuperAdminStatus` und `ticketStatusOptionsFor`: Die Auswahl hing an
 * der Art, und „In Entwicklung" war Super-Admins vorbehalten.
 *
 * Beides ist mit der einen Kette entfallen. Die Stufe heißt jetzt „In Arbeit"
 * und gilt für alle Arten — auch für eine Entscheidung, an der eine
 * Landesadministratorin gerade arbeitet. Wer die Auswahl braucht, nimmt
 * `TicketStatusOptions` direkt.
 */

export class TChangelogKind {
	static DEVELOPMENT = 'DEVELOPMENT'
	static DEPLOYMENT = 'DEPLOYMENT'
}

export const ChangelogKindOptions = [
	{ value: TChangelogKind.DEVELOPMENT, label: 'Entwicklung' },
	{ value: TChangelogKind.DEPLOYMENT, label: 'Auslieferung' }
]

export const ChangelogEnvOptions = [
	{ value: 'TEST', label: 'Test' },
	{ value: 'PROD', label: 'Produktion' }
]

export const ChangelogRepoOptions = [
	{ value: 'frontend', label: 'Oberfläche' },
	{ value: 'backend', label: 'Server' }
]

export class TConnectionStatus {
	static REQUESTED = 'REQUESTED'
	static CONNECTED = 'CONNECTED'
	static DECLINED = 'DECLINED'
	static ENDED = 'ENDED'
}

export class TCompanies {
	static JC = 'JC'
	static JBC = 'JBC'
	static JCC = 'JCC'
}

export class TNews {
	static NEWS = 'NEWS'
	static EVENT = 'EVENT'
}

export class TReports {
	static ANNUAL = 'ANNUAL'
	static SEMIANNUAL = 'SEMIANNUAL'
}

export class TParentalConfirmationTypes {
	static PDF = 'application/pdf'
}

export class TConsentDocumentTypes {
	static PDF = 'application/pdf'
}

export class TStates {
	static ALL = 'ALL' // тут не можна змінювати чи переклдати значення
	static BURGENLAND = 'BURGENLAND'
	static CARINTHIA = 'CARINTHIA'
	static LOWER_AUSTRIA = 'LOWER_AUSTRIA'
	static SALZBURG = 'SALZBURG'
	static STYRIA = 'STYRIA'
	static TYROL = 'TYROL'
	static UPPER_AUSTRIA = 'UPPER_AUSTRIA'
	static VIENNA = 'VIENNA'
	static VORARLBERG = 'VORARLBERG'
}

export class DOCUMENT_TYPES {
	static INVOICE = 'INVOICE'
	static REPORT = 'REPORT'
	static BUSINESS_PLAN = 'BUSINESS_PLAN'
	static PARENTAL_CONFIRMATION = 'PARENTAL_CONFIRMATION'
	static COURSE_CERTIFICATE = 'COURSE_CERTIFICATE'
	// Die von der Anwendung erzeugte Teilnahmebestätigung zur Lernstrecke.
	// Nicht mit COURSE_CERTIFICATE verwechseln — das ist der von außerhalb
	// hochgeladene Kursnachweis.
	static COURSE_PARTICIPATION = 'COURSE_PARTICIPATION'
	static CONSENT_DOCUMENT = 'CONSENT_DOCUMENT'
	static PARTICIPATION_DOCUMENT = 'PARTICIPATION_DOCUMENT'
	static COMPANY_CERTIFICATE = 'COMPANY_CERTIFICATE'
	static SHAREHOLDER_CERTIFICATE = 'SHAREHOLDER_CERTIFICATE'
	static SHARE_TEMPLATE = 'SHARE_TEMPLATE'
}
export class TGender {
	static MALE = 'MALE'
	static FEMALE = 'FEMALE'
	static DIVERS = 'DIVERS'
}

export const DocumentOptions = [
	{
		value: DOCUMENT_TYPES.INVOICE,
		label: 'Invoice'
	},
	{
		value: DOCUMENT_TYPES.REPORT,
		label: 'Business report'
	},
	{
		value: DOCUMENT_TYPES.BUSINESS_PLAN,
		label: 'Business plan'
	},
	{
		value: DOCUMENT_TYPES.PARENTAL_CONFIRMATION,
		label: 'Parental confirmation'
	},
	{
		value: DOCUMENT_TYPES.CONSENT_DOCUMENT,
		label: 'Consent document'
	},
	{
		value: DOCUMENT_TYPES.PARTICIPATION_DOCUMENT,
		label: 'Certificate of completion'
	},
	{
		value: DOCUMENT_TYPES.COMPANY_CERTIFICATE,
		label: 'Company certificate'
	},
	{
		value: DOCUMENT_TYPES.SHAREHOLDER_CERTIFICATE,
		label: 'Shareholder certificate'
	},
	{
		value: DOCUMENT_TYPES.SHARE_TEMPLATE,
		label: 'Shareholder certificate template'
	},
	{
		value: DOCUMENT_TYPES.COURSE_CERTIFICATE,
		label: 'Course certificate'
	},
	{
		value: DOCUMENT_TYPES.COURSE_PARTICIPATION,
		label: 'Course participation certificate'
	}
]

export const CompaniesOptions = [
	{
		value: TCompanies.JBC,
		label: 'JBC'
	},
	{
		value: TCompanies.JC,
		label: 'JC'
	},
	{
		value: TCompanies.JCC,
		label: 'JCC'
	}
]

export const CompaniesOptionsFull = [
	{
		value: TCompanies.JBC,
		label: 'Junior Basic Company'
	},
	{
		value: TCompanies.JC,
		label: 'Junior Company'
	},
	{
		value: TCompanies.JCC,
		label: 'Junior Compact Company'
	}
]

/*
 * Erreichbarkeit einer Expert:in — auf welchem Weg und wann eine
 * Kontaktaufnahme passt (Backend: CONTACT_MODE / CONTACT_TIME). Die
 * Beschriftungen kommen aus der Sprachdatei (`contactMode…` / `contactTime…`),
 * gespeichert wird der Rohwert.
 */
export const TContactModes = ['EMAIL', 'PHONE', 'VIDEO', 'ON_SITE', 'CHAT']

export const TContactTimes = ['WEEKDAY_MORNING', 'WEEKDAY_AFTERNOON', 'WEEKDAY_EVENING', 'WEEKEND', 'BY_ARRANGEMENT']

/*
 * Bundeslaender mit deutschen Bezeichnungen.
 *
 * Die Beschriftungen waren englisch (Carinthia, Lower Austria, Vienna ...) und
 * standen damit auch in der deutschen Oberflaeche - in Unternehmen, Schulen,
 * Benutzer:innen und in saemtlichen Filtern.
 *
 * Nur die Anzeige ist betroffen. Die gespeicherten Werte kommen aus TStates
 * und sind unveraendert; an der Datenbank aendert sich nichts.
 *
 * Bei Salzburg war ein Leerzeichen am Ende, das die Suche in react-select
 * gestoert hat.
 */
export const StateOptions = [
	// TStates.ALL must be added separately
	{
		value: TStates.BURGENLAND,
		label: 'Burgenland'
	},
	{
		value: TStates.CARINTHIA,
		label: 'Kärnten'
	},
	{
		value: TStates.LOWER_AUSTRIA,
		label: 'Niederösterreich'
	},
	{
		value: TStates.SALZBURG,
		label: 'Salzburg'
	},
	{
		value: TStates.STYRIA,
		label: 'Steiermark'
	},
	{
		value: TStates.TYROL,
		label: 'Tirol'
	},
	{
		value: TStates.UPPER_AUSTRIA,
		label: 'Oberösterreich'
	},
	{
		value: TStates.VIENNA,
		label: 'Wien'
	},
	{
		value: TStates.VORARLBERG,
		label: 'Vorarlberg'
	}
]

/*
 * Kurzform der Bundeslaender — die in Oesterreich uebliche Abkuerzung
 * (Statistik Austria: Bgld, Ktn, NOE, OOE, Sbg, Stmk, T, Vbg, W).
 *
 * Angezeigt wird ein Bundesland ueberall in dieser Kurzform (`stateLabel`),
 * weil es in Listen sonst zwei Zeilen braucht. Ausgeschrieben steht es nur
 * dort, wo ein Bundesland ausgewaehlt wird (Auswahlfelder, Filter) — dafuer
 * gibt es `stateFullLabel`.
 */
export const StateShortLabels = {
	[TStates.BURGENLAND]: 'Bgld',
	[TStates.CARINTHIA]: 'Ktn',
	[TStates.LOWER_AUSTRIA]: 'NÖ',
	[TStates.SALZBURG]: 'Sbg',
	[TStates.STYRIA]: 'Stmk',
	[TStates.TYROL]: 'T',
	[TStates.UPPER_AUSTRIA]: 'OÖ',
	[TStates.VIENNA]: 'W',
	[TStates.VORARLBERG]: 'Vbg'
}

// Größenklasse „Anzahl Schüler:innen" einer Schule (Anforderung #9). Die Werte
// müssen mit SCHOOL_STUDENT_COUNT im Backend übereinstimmen; die Labels sind
// reine Zahlbereiche und damit sprachneutral.
export const SchoolStudentCountOptions = [
	{ value: 'LT_500', label: '< 500' },
	{ value: 'FROM_500_TO_2000', label: '500 – 2000' },
	{ value: 'GT_2000', label: '> 2000' }
]

/*
 * Wie das Skills4Retail-Konzept heißt.
 *
 * **Skills4Retail ist das Programm, „Marketing & E-Commerce" das Thema.** Die
 * Oberfläche nannte bisher nur das Programm — „Skills4Retail-Konzept" sagt
 * niemandem, worum es in den fünfzehn Feldern geht, und sobald ein zweites
 * Konzept aus demselben Programm dazukommt, unterscheidet der Name die beiden
 * nicht mehr.
 *
 * Der Name steht hier und nicht in jeder Ansicht: Er erscheint an vier Stellen
 * (Fenster der Auswertung, Ansicht der Schüler:innen, Ansicht der Lehrkraft,
 * öffentliche Seite) und muss überall derselbe sein.
 */
export const CONCEPT_NAME = 'Marketing & E-Commerce'

export const TWidgetTypes = {
	LINK: 'LINK',
	TWO_SECTIONS: 'TWO_SECTIONS',
	THREE_SECTIONS: 'THREE_SECTION',
	FOUR_SECTIONS: 'FOUR_SECTIONS',
	FOUR_SECTIONS_DATA: 'FOUR_SECTIONS_DATA'
}

export const TReject = {
	COMPANY: 'COMPANY',
	PARENTAL: 'PARENTAL'
}

export const TWidgetDomains = {
	COMPANIES: 'COMPANIES',
	STUDENTS: 'STUDENTS',
	TEACHERS: 'TEACHERS',
	INVOICES: 'INVOICES',
	REPORTS: 'REPORTS',
	TURNOVER: 'TURNOVER',
	COMPANIES_PENDING: 'COMPANIES_PENDING',
	OVERDUE_INVOICES: 'OVERDUE_INVOICES',
	REPORT_DATA: 'REPORT_DATA'
}

export const optionsDate = {
	day: '2-digit',
	month: '2-digit',
	year: 'numeric',
	hour: 'numeric',
	minute: '2-digit',
	second: '2-digit'
}
export const optionsDateWhioutTime = {
	day: '2-digit',
	month: '2-digit',
	year: 'numeric'
}

export const TNotifications = {
	COMPANY_CONFIRMATION: 'COMPANY_CONFIRMATION',
	PARENTAL_CONFIRMATION: 'PARENTAL_CONFIRMATION',
	TEACHER_CONFIRMATION: 'TEACHER_CONFIRMATION',
	REJECT_COMPANY: 'REJECT_COMPANY',
	REPORT_SUBMITTING: 'REPORT_SUBMITTING',
	USERS_JOINING: 'USERS_JOINING',
	PAYMENT_REQUEST: 'PAYMENT_REQUEST',
	PAYMENT_DONE: 'PAYMENT_DONE',
	PROGRAM_FINISH: 'PROGRAM_FINISH',
	NEED_REVIEW: 'NEED_REVIEW',
	REJECT_PARENTAL: 'REJECT_PARENTAL',
	ASSIGN_REQUEST: 'ASSIGN_REQUEST',
	REJECT_ASSIGN_REQUEST: 'REJECT_ASSIGN_REQUEST',
	INVOICE_PAYMENT_REMINDER: 'INVOICE_PAYMENT_REMINDER',
	REJECT_REPORT: 'REJECT_REPORT',
	REPORT_REMINDER: 'REPORT_REMINDER',
	INVITE_EMPLOYEE: 'INVITE_EMPLOYEE',
	INVITE_TEACHER: 'INVITE_TEACHER',
	ADD_EXPERT: 'ADD_EXPERT',
	CONFIRM_EXPERT: 'CONFIRM_EXPERT',
	EXPERT_RECORD_REMOVED: 'EXPERT_RECORD_REMOVED',
	SUBMIT_RISK: 'SUBMIT_RISK',
	SUBMIT_BUSINESS_PLAN: 'SUBMIT_BUSINESS_PLAN',
	SUBMIT_PARENTAL: 'SUBMIT_PARENTAL',
	SUBMIT_COURSE_CERTIFICATE: 'SUBMIT_COURSE_CERTIFICATE',
	COURSE_CERTIFICATE_CONFIRMATION: 'COURSE_CERTIFICATE_CONFIRMATION',
	REJECT_COURSE_CERTIFICATE: 'REJECT_COURSE_CERTIFICATE',
	/*
	 * Kurse mit Urkunde (Kursverwaltung, KI-Kurs). Bewusst mit „LEARNING_"
	 * davor: COURSE_COMPLETED und COURSE_COMPLETED_TEACHER (weiter unten)
	 * gehören der Lernstrecke Skills4Retail und tragen andere Angaben.
	 */
	LEARNING_COURSE_COMPLETED: 'LEARNING_COURSE_COMPLETED',
	LEARNING_COURSE_COMPLETED_TEACHER: 'LEARNING_COURSE_COMPLETED_TEACHER',
	LEARNING_COURSE_CREDIT_CAP_REACHED: 'LEARNING_COURSE_CREDIT_CAP_REACHED',
	// Die Lehrkraft hat einen Nachweis entfernt (Anforderung #94). Getrennt von
	// den REJECT_-Nachrichten: Dort liegt die Datei noch, hier ist sie weg.
	REQUIREMENT_DOCUMENT_REMOVED: 'REQUIREMENT_DOCUMENT_REMOVED',
	FINISH_COMPANY: 'FINISH_COMPANY',
	FIRST_ENTER: 'FIRST_ENTER',
	ACTIVATE_COMPANY_REMINDER: 'ACTIVATE_COMPANY_REMINDER',
	SUBMIT_APPROVAL_COMPANY_REMINDER: 'SUBMIT_APPROVAL_COMPANY_REMINDER',
	INVOICE_GENERATED: 'INVOICE_GENERATED',
	INVOICE_PART_PAID: 'INVOICE_PART_PAID',
	TEACHER_FIRST_ENTER: 'TEACHER_FIRST_ENTER',
	TEACHER_NEW_COMPANY: 'TEACHER_NEW_COMPANY',
	TEACHER_COMPANY_ACTIVATED: 'TEACHER_COMPANY_ACTIVATED',
	TEACHER_REPORT_SUBMITTED: 'TEACHER_REPORT_SUBMITTED',
	TEACHER_FINANCIAL_REPORT_SUBMITTED: 'TEACHER_FINANCIAL_REPORT_SUBMITTED',
	TEACHER_REPORT_REMINDER: 'TEACHER_REPORT_REMINDER',
	TEACHER_INVOICE_REMINDER: 'TEACHER_INVOICE_REMINDER',
	COMPANY_READY_FOR_SUBMISSION: 'COMPANY_READY_FOR_SUBMISSION',
	REPORT_SUBMITTING_FINAL_REPORT: 'REPORT_SUBMITTING_FINAL_REPORT',
	CREATING_NEWS: 'CREATING_NEWS',
	CREATING_EVENT: 'CREATING_EVENT',
	// Nachricht der Verwaltung aus dem Verlauf des Firmenprofils
	COMPANY_LOG_MESSAGE: 'COMPANY_LOG_MESSAGE',

	// Lebensmittelhygiene und Allergeninformation (Anforderung #96): Bestätigung
	// der Schüler:innen an die Lehrkraft, deren Widerspruch zurück an die
	// Schüler:innen, Erinnerung an die noch offene Schulung an beide.
	HYGIENE_CONFIRMED: 'HYGIENE_CONFIRMED',
	HYGIENE_OBJECTION: 'HYGIENE_OBJECTION',
	HYGIENE_TRAINING_REMINDER: 'HYGIENE_TRAINING_REMINDER',

	// Ankündigung des Jahresresets: geht an Schüler:innen (über die Junior
	// Company) und an Lehrkräfte. `info` trägt Datum und verbleibende Tage.
	SCHOOL_YEAR_RESET_REMINDER: 'SCHOOL_YEAR_RESET_REMINDER',

	/*
	 * Anfragen über den Hilfe-Knopf (Anfragen-Konzept, Stufe 2).
	 * REQUEST_RECEIVED bestätigt der meldenden Person den Eingang samt Nummer,
	 * REQUEST_NEW meldet der zuständigen Administration eine neue Anfrage.
	 */
	REQUEST_RECEIVED: 'REQUEST_RECEIVED',
	REQUEST_NEW: 'REQUEST_NEW',

	/*
	 * Der Rückweg (Stufe 3) und das Nachhalten (Stufe 4).
	 * ANSWERED und QUESTION gehen an die meldende Person, REPLY und OVERDUE an
	 * die Verwaltung. CLOSED und REJECTED schließen ab.
	 */
	REQUEST_ANSWERED: 'REQUEST_ANSWERED',
	REQUEST_QUESTION: 'REQUEST_QUESTION',
	REQUEST_CLOSED: 'REQUEST_CLOSED',
	REQUEST_REJECTED: 'REQUEST_REJECTED',
	REQUEST_REPLY: 'REQUEST_REPLY',
	REQUEST_OVERDUE: 'REQUEST_OVERDUE',

	/*
	 * Wirtschaftsexpert:in hat zugesagt (Anforderung #232): an die
	 * Schüler:innen, an die Lehrkräfte, und nach Ablauf der Frist die
	 * Rückfrage mit Ja/Nein (`UI/NotificationItem/ContactCheck`).
	 */
	SUPPORTER_REQUEST_ACCEPTED: 'SUPPORTER_REQUEST_ACCEPTED',
	SUPPORTER_REQUEST_ACCEPTED_TEACHER: 'SUPPORTER_REQUEST_ACCEPTED_TEACHER',
	SUPPORTER_CONTACT_CHECK: 'SUPPORTER_CONTACT_CHECK',

	/*
	 * Skills4Retail-Konzept.
	 *
	 * **Diese vier fehlten hier bis 25.08.2026.** Die Zweige dafür standen in
	 * `UI/NotificationItem` seit dem ersten Tag — nur hieß der Vergleichswert
	 * dort `TNotifications.CONCEPT_SUBMITTED`, und das war `undefined`. Keiner
	 * der Zweige konnte je greifen, `getLayoutNotifications` fiel auf `default`
	 * und lieferte `null`: Die Mitteilung wurde gar nicht gezeigt. Eine
	 * Lehrkraft erfuhr in der Liste nichts davon, dass eine Junior Company ihr
	 * Konzept zur Bewertung abgeschlossen hatte.
	 */
	CONCEPT_SUBMITTED: 'CONCEPT_SUBMITTED',
	CONCEPT_RETURNED: 'CONCEPT_RETURNED',
	CONCEPT_SCORED: 'CONCEPT_SCORED',
	CONCEPT_ASSESSMENT_REMINDER: 'CONCEPT_ASSESSMENT_REMINDER',

	// Jemand hat die Lernstrecke abgeschlossen: die Gratulation an die Person
	// selbst, der Stand an die betreuende Lehrkraft.
	COURSE_COMPLETED: 'COURSE_COMPLETED',
	COURSE_COMPLETED_TEACHER: 'COURSE_COMPLETED_TEACHER'
}

export const genderOption = [
	{
		value: TGender.MALE,
		label: 'Männlich'
	},
	{
		value: TGender.FEMALE,
		label: 'Weiblich'
	},
	{
		value: TGender.DIVERS,
		label: 'Divers'
	}
]
export class TLanguages {
	static EN = 'en'
	static DE = 'ger'
}
